import { jsxs as p, jsx as n } from "react/jsx-runtime";
import { forwardRef as s } from "react";
import { TooltipTrigger as a, Tooltip as d } from "./index.js";
function u(t) {
  return s(function(i, r) {
    const { tooltip: e, ...l } = i, o = !e?.children || e.isDisabled;
    return /* @__PURE__ */ p(
      a,
      {
        delay: e?.delay,
        isDisabled: o,
        isOpen: e?.isOpen,
        defaultOpen: e?.defaultOpen,
        onOpenChange: e?.onOpenChange,
        children: [
          /* @__PURE__ */ n(t, { ...l, ref: r }),
          !o && /* @__PURE__ */ n(d, { placement: e.placement, children: e.children })
        ]
      }
    );
  });
}
export {
  u as withTooltip
};
//# sourceMappingURL=withTooltip.js.map
